import { EnergyType } from '../EnergyFlow'
import { InefficientProvider } from './common/InefficientProvider'

export class ElectricBoilerProvider extends InefficientProvider {
  public readonly providedEnergyTypes = [EnergyType.Heating]

  protected mapDemandToRequirementEnergyType(): EnergyType {
    return EnergyType.Electricity
  }

  protected mapDemandToWasteEnergyType(): EnergyType {
    return EnergyType.Heating
  }
}
